import MapGeoJsonService from "../../services/MapGeoJsonService";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Spinner } from "react-bootstrap";
import { mdiClose, mdiChevronRight } from "@mdi/js";
import Select from "react-select";

import BanAutoComplete from "./BanAutoComplete";
import SearchSection from "./SearchSection";
import SearchLieu from "./SearchLieu";
import SearchProprietaire from "./SearchProprietaire";
import SearchIndivision from "./SearchIndivision";
import SearchCompteCommune from "./SearchCompteCommune";

//For Pros
import SearchFoncierResiduel from "./SearchFoncierResiduel";
import SearchNonBatiZU from "./SearchNonBatiZU";
import SearchParcellesZoneAgricole from "./SearchParcellesZoneAgricole";
import SearchPropPersonnesMorales from "./SearchPropPersonnesMorales";

import SearchZoneUrbanisme from "./SearchZoneUrbanisme";
import SearchUrbaPrecriptionSurf from "./SearchUrbaPrecriptionSurf";

//Permis de construire
import SearchPermisAmenager from "./SearchPermisAmenager";
import SearchPermisContrLocaux from "./SearchPermisContrLocaux";
import SearchDeclarationsPrealables from "./SearchDeclarationsPrealables";
import SearchPermisConstruire from "./SearchPermisConstruire";

import Icon from "@mdi/react";
import styles from "./FilterTools.scss";

const FilterTools = (props) => {
   const [showTool, setShowTools] = useState("none");
   const [filterChoice, setFilterChoice] = useState({
      label: "CADASTRE",
      value: "com",
   });
   const [noAccess, setNoAccess] = useState([]);
   const [propType, setPropType] = useState("physique");
   const [bati, setBati] = useState(true);
   const [options, setOptions] = useState([]);
   const [loading, setLoading] = useState(false);
   let mapGeoJsonService = new MapGeoJsonService();
   
   useEffect(() => {
      if (props.showSearchTools) {
         props.clearParcelleList(); // Clear when the search tools are displayed
      }
   }, [props.showSearchTools]);
   
   const selectInputStyles = {
      // Existing styles
      option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? "#3c5459" : state.isDisabled ? "#CCC" : "#f2f2f2",
        backgroundColor: state.isSelected ? "#58D2C3" : "#3c5459",
        fontSize: "0.85rem",
        cursor: "pointer",
        width: "100%",
        ":hover": { backgroundColor: "#58D2C3" }, // Corrected from ":over" to ":hover"
        ":before": state.isDisabled
          ? {
              backgroundColor: "#58D2C3",
              borderRadius: "0px",
              fontSize: "0.75rem",
              color: "#CCCCCC",
              padding: "0px",
              content: '"PRO"',
              display: "inline-block",
              marginRight: 8,
            }
          : null,
      }),
      control: () => ({
        display: "flex",
        height: "35px",
        width: "88%",
        minWidth: "170px",
        flexGrow: 1,
        fontSize: "13px",
        fontWeight: "700",
        backgroundColor: "#253437",
        color: "#FFFFFF",
        textAlign: "center",
        borderRadius: "0.3rem",
        borderTopLeftRadius: "0",
        borderBottomLeftRadius: "0",
        cursor: "pointer",
      }),
      singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const color = "#FFFFFF";
        const width = "100%";
        const transition = "opacity 300ms";
        return { ...provided, opacity, transition, color, width };
      },
      
      // New styles to override default menu and menuList
      menu: (provided) => ({
        ...provided,
        backgroundColor: "#3c5459", // Adjust as needed
        border: "none", // Removes border
        borderRadius: "0", // Removes rounded corners
        marginTop: "0px", // Optional: Adjust spacing
      }),
      menuList: (provided) => ({
        ...provided,
        padding: "0px", // Removes default padding
      }),
    };
   
   useEffect(() => {
      setOptions([
         { label: "CADASTRE", value: "com" },
         { label: "LIEU-DIT", value: "lieu" },
         {
            label: "PARCELLES HISTORIQUES",
            value: "histo",
            isDisabled: true,
         },
         { label: "PROPRIÉTAIRE BÂTI", value: "prop", isDisabled: true },
         {
            label: "PROPRIÉTAIRE TERRAIN",
            value: "prop_nonbati",
            isDisabled: true,
         },
         {
            label: "PROPRIÉTAIRE INDIVISION",
            value: "indivi",
            isDisabled: props.currentEntity ? false : true,
         },
         {
            label: "PROPRIÉTAIRE COMPTE COMMUNAL",
            value: "cpte_comm",
            isDisabled: props.currentEntity ? false : true,
         },
      ]);
   }, []);

   useEffect(() => {
      setOptions([
         { label: "CADASTRE", value: "com" },
         { label: "LIEU-DIT", value: "lieu" },
         {
            label: "PARCELLES HISTORIQUES",
            value: "histo",
            isDisabled: props.currentEntity ? false : true,
         },
         {
            label: "PROPRIÉTAIRE BÂTI",
            value: "prop",
            isDisabled: props.currentEntity ? false : true,
         },
         {
            label: "PROPRIÉTAIRE TERRAIN",
            value: "prop_nonbati",
            isDisabled: props.currentEntity ? false : true,
         },
         {
            label: "PROPRIÉTAIRE INDIVISION",
            value: "indivi",
            isDisabled: props.currentEntity ? false : true,
         },
         {
            label: "PROPRIÉTAIRE COMPTE COMMUNAL",
            value: "cpte_comm",
            isDisabled: props.currentEntity ? false : true,
         },
         {
            label: "PROPRIÉTAIRE PERSONNE MORALE",
            value: "prop_pers_morale",
            isDisabled: props.currentEntity ? false : true,
         },
         {
            label: "FONCIER RESIDUEL ZONE URBAINE (U)",
            value: "fonc_resid_zu",
            isDisabled: props.currentEntity ? false : true,
         },
         {
            label: "FONCIER RESIDUEL UNITE FONCIERE (U)",
            value: "fonc_resid_zu_uf",
            isDisabled: props.currentEntity ? false : true,
         },
         {
            label: "FONCIER RESIDUEL AGRICOLE (A)",
            value: "fonc_resid_a",
            isDisabled: props.currentEntity ? false : true,
         },
         {
            label: "FONCIER RESIDUEL UNITE FONCIERE (A)",
            value: "fonc_resid_a_uf",
            isDisabled: props.currentEntity ? false : true,
         },
         {
            label: "NON-BATI ZONE URBAINE",
            value: "non_bati_zu",
            isDisabled: props.currentEntity ? false : true,
         },
         {
            label: "PARCELLES ZONE AGRICOLE",
            value: "parc_zone_a",
            isDisabled: props.currentEntity ? false : true,
         },
         {
            label: "URBANISME - ZONE",
            value: "zone_urba",
            isDisabled: props.currentEntity ? false : true,
         },
         {
            label: "URBANISME - PRESCRIPTION (SURF)",
            value: "urba_presc_surf",
            isDisabled: props.currentEntity ? false : true,
         },
         {
            label: "(PA) Permis d'aménager",
            value: "permis_pa",
            isDisabled: props.currentEntity ? false : true,
         },
         {
            label: "(PC) PERMIS DE CONSTRUIRE LOCAUX",
            value: "permis_loc",
            isDisabled: props.currentEntity ? false : true,
         },
         {
            label: "(PC) PERMIS DE CONSTRUIRE LOGEMENTS",
            value: "permis_pc",
            isDisabled: props.currentEntity ? false : true,
         },
         {
            label: "(DP) DECLARATIONS PREALABLES",
            value: "permis_dp",
            isDisabled: props.currentEntity ? false : true,
         },
      ]);
   }, [props.userId, props.currentEntity]);

   useEffect(() => {
      props.currentEntity &&
      props.currentEntity.genre &&
      props.currentEntity.genre.slug == "collective" &&
      props.userSubscription
         ? setNoAccess(["zu", "pu", "info"])
         : setNoAccess(["zu", "pu", "info", "prop"]);
   }, [showTool]);

   useEffect(() => {
      setShowTools("none");
      props.setFilterToolsState(filterChoice);
   }, [filterChoice]);

   const handleFilterPanel = (e) => {
      if (e != "none") {
         showTool === "none" ? setShowTools("flex") : setShowTools("none");
         props.clearParcelleList();
         props.setDisplayPropList(false);
         props.setDisplayHistoriqueList(false);
         props.cleanVectorLayer();
      }
   };

   useEffect(() => {
      if (props.filterChoiceState) {
   
         setFilterChoice(props.filterChoiceState);
         props.filterChoiceState === "prop_nonbati" ? setBati(false) : setBati(true);
      }
   }, [props.filterChoiceState]);

   const handleFilterChoice = (e) => {
      e.value === "prop_nonbati" ? setBati(false) : setBati(true);
      props.setFilterChoice(e.value);
   };

   const handleCloseFilterTools = (e) => {
      if (filterChoice === "prop" 
         || filterChoice === "prop_nonbati" 
         || filterChoice === "histo" 
         || filterChoice === "indivi"
         || filterChoice === "prop_pers_morale"
         || filterChoice === "fonc_resid_zu"
         || filterChoice === "fonc_resid_zu_uf"
         || filterChoice === "fonc_resid_a"
         || filterChoice === "fonc_resid_a_uf"
         || filterChoice === "non_bati_zu"
         || filterChoice === "parc_zone_a"
         || filterChoice === "zone_urba"
         || filterChoice === "urba_presc_surf"
         || filterChoice === "permis_loc"
         || filterChoice === "permis_dp"
         || filterChoice === "permis_pc"
         || filterChoice === "permis_pa"

      ) {
         //console.log('le filterchoice est', filterChoice)
      } else {
         mapGeoJsonService.clearVectorLayer();
         props.cleanVectorLayer(false);
         props.setDisplayPropList(false);
         props.setDisplayHistoriqueList(false);
      }
      props.setShowSearchPanel(false);
   };

   return props.showSearchTools ? (
      <div id={"filter-tools-wrapper"}>
         <div id={"filter-tools"} className={"d-flex flex-column"}>
            <form className="d-flex flex-column justify-content-center flex-grow-1 flex-md-grow-0 mx-md-auto pr-4 pl-4 pb-4 ">

               <div className={"d-block d-md-none my-2"}>Type de recherche :</div>
               <div
                  className={"d-flex justify-content-between align-items-center p-0 h-30 px-2 rounded mb-1"}
                  style={{
                     backgroundColor: "var(--theme-page-background)",
                  }}
               >
                  {loading ? (
                     <Spinner
                        animation="border"
                        variant={"primary"}
                        size={"sm"}
                        className={"d-inline-block mx-1 my-auto"}
                     />
                  ) : (
                     <></>
                  )}

                  {/* Wrapper to center the Select */}
                  <div
                     className={"d-flex flex-grow-1 justify-content-center align-items-center mt-2"}
                     style={{ minWidth: 0, paddingLeft: 18, height: "35px",
                        width: "88%",
                        minWidth: "170px",
                        flexGrow: 1,
                        fontSize: "13px",
                        fontWeight: "700", }} 
                  >{options.find((option) => option.value === filterChoice).label}
                     
                  </div>

                  {/* Close button */}
                  <button
                     type="button"
                     className="close"
                     onClick={() => handleCloseFilterTools(false)}
                     aria-label="Fermer"
                     style={{
                        flexShrink: 0, // Ensures the button does not shrink
                        marginLeft: "10px", // Adds space between the Select and the button
                     }}
                  >
                     <span aria-hidden="true" style={{ fontSize: "x-large", color: "#ffffff" }}>
                        &times;
                     </span>
                  </button>
               </div>

                     
               {filterChoice === "address" ? (
                  <BanAutoComplete loading={setLoading} />
               ) : filterChoice === "prop" ||
                 filterChoice === "prop_nonbati" ||
                 filterChoice === "prop_moral" ||
                 filterChoice === "prop_moral_nonbati" ? (
                  <SearchProprietaire loading={setLoading} propType={propType} bati={bati} handleCloseFilterTools={handleCloseFilterTools} />
               ) : filterChoice === "lieu" ? (
                  <SearchLieu loading={setLoading} />
               ) : filterChoice === "histo" ? (
                  <SearchSection loading={setLoading} searchType={"histo"} />
               ) : filterChoice === "indivi" ? (
                  <SearchIndivision loading={setLoading} propType="indivi" bati={bati} handleCloseFilterTools={handleCloseFilterTools} />
               ) : filterChoice === "cpte_comm" ? (
                  <SearchCompteCommune loading={setLoading} propType="cpte_comm" handleCloseFilterTools={handleCloseFilterTools} />
               ) : filterChoice === "prop_pers_morale" ? (
                  <SearchPropPersonnesMorales loading={setLoading} searchType={"prop_pers_morale"} clearVectorLayer={mapGeoJsonService.clearPropParcelleLayers} />
               ) : filterChoice === "fonc_resid_zu" ? (
                  <SearchFoncierResiduel loading={setLoading} searchType={"fonc_resid_zu"} clearVectorLayer={mapGeoJsonService.clearPropParcelleLayers} />
               ) : filterChoice === "fonc_resid_zu_uf" ? (
                  <SearchFoncierResiduel loading={setLoading} searchType={"fonc_resid_zu_uf"} clearVectorLayer={mapGeoJsonService.clearPropParcelleLayers} />
               ) : filterChoice === "fonc_resid_a" ? (
                  <SearchFoncierResiduel loading={setLoading} searchType={"fonc_resid_a"} clearVectorLayer={mapGeoJsonService.clearPropParcelleLayers} />
               ) : filterChoice === "fonc_resid_a_uf" ? (
                  <SearchFoncierResiduel loading={setLoading} searchType={"fonc_resid_a_uf"} clearVectorLayer={mapGeoJsonService.clearPropParcelleLayers} />
               ) : filterChoice === "non_bati_zu" ? (
                  <SearchNonBatiZU loading={setLoading} clearVectorLayer={mapGeoJsonService.clearPropParcelleLayers} />
               ) : filterChoice === "parc_zone_a" ? (
                  <SearchParcellesZoneAgricole loading={setLoading} searchType={"parc_zone_a"} clearVectorLayer={mapGeoJsonService.clearPropParcelleLayers} />
               ) : filterChoice === "zone_urba" ? (
                  <SearchZoneUrbanisme loading={setLoading} searchType={"zone_urba"} clearVectorLayer={mapGeoJsonService.clearZoneLayer} />
               ) : filterChoice === "urba_presc_surf" ? (
                  <SearchUrbaPrecriptionSurf loading={setLoading} searchType={"urba_presc_surf"} clearVectorLayer={mapGeoJsonService.clearZoneLayer} />
               ) : filterChoice === "permis_pa" ? (
                  <SearchPermisAmenager loading={setLoading} searchType={"permis_pa"} clearVectorLayer={mapGeoJsonService.clearPropParcelleLayers} />
               ) : filterChoice === "permis_loc" ? (
                  <SearchPermisContrLocaux loading={setLoading} searchType={"permis_loc"} clearVectorLayer={mapGeoJsonService.clearPropParcelleLayers} />
               ) : filterChoice === "permis_dp" ? (
                  <SearchDeclarationsPrealables loading={setLoading} searchType={"permis_dp"} clearVectorLayer={mapGeoJsonService.clearPropParcelleLayers} />
               ) : filterChoice === "permis_pc" ? (
                  <SearchPermisConstruire loading={setLoading} searchType={"permis_pc"} clearVectorLayer={mapGeoJsonService.clearPropParcelleLayers} />
               ) : (
                  <SearchSection loading={setLoading} />
               )}

               <div
                  id={"ue-search-btn"}
                  className={"d-flex d-md-none flex-column justify-content-end flex-grow-1 flex-md-grow-0 "}
               >
                  <div
                     className={"btn btn-lg btn-md btn-primary text-light my-md-auto"}
                     onClick={(e) => props.setShowSearchPanel(!props.showSearchTools)}
                  >
                     {loading ? (
                        <Spinner animation="border" size={"sm"} className={"d-inline-block ml-3 mt-2"} />
                     ) : (
                        <div id={"ue-search-close-btn"} onClick={() => handleCloseFilterTools(false)}>
                           Fermer
                           <Icon path={mdiClose} size={1.3} color={"#FFF"} />
                        </div>
                     )}
                  </div>
               </div>

               <div id={"ue-search-btn-desktop"} className={"d-none d-md-block my-auto"}>
                  {}
               </div>
            </form>
         </div>
      </div>
   ) : null;
};

const mapStateToProps = (state) => {
   return {
      userId: state.MeReducer.id,
      username: state.MeReducer.username,
      role: state.MeReducer.role,
      currentEntity: state.MeReducer.entity,
      currentSection: state.LeftPanelReducer.currentSection,
      userSubscription: state.MeReducer.subscription,
      showSearchTools: state.LeftPanelReducer.showSearchTools,
      filterChoiceState: state.FilterToolsReducer.filterChoiceState,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      displayPropList: (e) =>
         dispatch({
            type: "DISPLAY_PROP_LIST_PARCELLES",
            data: { displayPropList: e },
         }),
      setDisplayPropList: (e) =>
         dispatch({
            type: "DISPLAY_PROP_LIST_PARCELLES",
            data: { displayPropList: e },
         }),
      setDisplayHistoriqueList: (e) =>
         dispatch({
            type: "DISPLAY_HISTORIQUE_LIST_PARCELLES",
            data: { displayHistoriqueList: e },
         }),
      cleanVectorLayer: (e) => dispatch({ type: "CLEAR_VECTOR_LAYER", data: e }),
      setFilterToolsState: (e) =>
         dispatch({
            type: "SET_FILTER_TOOLS_STATE",
            data: { filterToolsState: e },
         }),
      setShowSearchPanel: (e) => dispatch({ type: "SHOW_SEARCH_PANEL", data: e }),
      setFilterChoice: (e) => dispatch({ type: "CHANGE_FILTER_CHOICE", data: e }),
      clearParcelleList: () => dispatch({ type: "CLEAR_PARCELLE_LIST" }),

   };
};

export default connect(mapStateToProps, mapDispatchTProps)(FilterTools);
